<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="container">
	<div class="pref-layout">
		<div class="border rounded-3 shadow-sm p-4 p-md-5 d-flex flex-column align-items-center justify-content-center gap-3 bg-white pref-container pref-card">
			<div class="d-flex flex-column align-items-center gap-2 w-100">
				<p class="m-0 text-center fs-5 pref-title">
					{{locale.translations['user']['wa-alerts']['n743']}}
				</p>
				<p class="m-0 text-center text-muted pref-subtitle d-flex align-items-center justify-content-center gap-2">
					<span>
						{{locale.translations['user']['wa-alerts']['n744']}}
					</span>
				</p>
				<ul class="pref-benefits list-unstyled mb-0">
					<li class="d-flex align-items-center gap-2">
						<mat-icon color="primary">check_circle</mat-icon>
						<span>
							{{locale.translations['user']['wa-alerts']['n745']}}
						</span>
					</li>
					<li class="d-flex align-items-center gap-2">
						<mat-icon color="primary">check_circle</mat-icon>
						<span>
							{{locale.translations['user']['wa-alerts']['n746']}}
						</span>
					</li>
					<li class="d-flex align-items-center gap-2">
						<mat-icon color="primary">check_circle</mat-icon>
						<span>
							{{locale.translations['user']['wa-alerts']['n747']}}
						</span>
					</li>
				</ul>
			</div>

			<form [formGroup]="form" class="d-flex flex-column gap-4 align-items-center w-100 mt-3">
				<div class="field-group w-100">
					<label class="field-label w-100">
						{{locale.translations['user']['wa-alerts']['n748']}}
					</label>

                    <mat-form-field appearance="outline" floatLabel="never" class="w-100" [ngClass]="{'no-subscript':!(	form.get('make') &&
										form.get('make').touched &&
										form.get('make').invalid)}">
                        <mat-select
                          multiple
                         formControlName="make"
                         (selectionChange)="onSelectChange($event)"
                          panelClass="tall-select-panel" placeholder="{{locale.translations['user']['wa-alerts']['n749']}}" aria-label="Select car make or model preference"
                        >

                        <mat-select-trigger>
                            {{ selectedCarsTrigger }}
                        </mat-select-trigger>

                        <mat-option
                        [value]="'0'"
                        (onSelectionChange)="onAllToggled($event)"
                      >
                        {{ ALL }}
                      </mat-option>

                          <mat-option *ngFor="let car of carListNoAll" [value]="car.id">
                            {{ car.name }}
                          </mat-option>
                        </mat-select>

						<mat-error
									*ngIf="
										form.get('make') &&
										form.get('make').touched &&
										form.get('make').invalid
									"
								>
									{{locale.translations['user']['wa-alerts']['n754']}}
								</mat-error>

                      </mat-form-field>
				</div>

				<div class="field-group w-100">
					<label class="field-label w-100">
						{{locale.translations['user']['wa-alerts']['n750']}}
					</label>
					<mat-form-field appearance="outline" floatLabel="never" class="w-100" [ngClass]="{'no-subscript': !(form.get('year') && form.get('year').touched && form.get('year').invalid)}">
                        <mat-select formControlName="year" placeholder="{{locale.translations['user']['wa-alerts']['n751']}}" aria-label="Select preferred year range">
                            <mat-option *ngFor="let year of yearList" [value]="year">
                                {{ year }}
                            </mat-option>
                        </mat-select>

						<mat-error
									*ngIf="
										form.get('year') &&
										form.get('year').touched &&
										form.get('year').invalid
									"
								>
									{{locale.translations['user']['wa-alerts']['n754']}}
								</mat-error>
                    </mat-form-field>
				</div>

				<mat-divider class="w-100 my-3"></mat-divider>

				<button mat-flat-button type="submit" color="primary" id="apply-btn" class="w-200px py-2 submit-btn" (click)="onSubmit()">
                    <mat-icon class="material-icons-outlined">notifications</mat-icon>
                   {{locale.translations['user']['wa-alerts']['n752']}}
				</button>

				<p class="text-muted small m-0 text-center">
					{{locale.translations['user']['wa-alerts']['n753']}}
				</p>
			</form>
		</div>

		<div class="video-side d-flex align-items-start justify-content-center">
			<div slot="video" class="vertical-video video--large" aria-label="دۆزینەوەی ئۆتۆمێل لە رێگەی وەتس ئەپ">
				<iframe
					src="https://www.youtube.com/embed/F6mZpAiBJH4?rel=0&modestbranding=1&controls=1&playsinline=1&iv_load_policy=3"
					title="دۆزینەوەی ئۆتۆمێل لە رێگەی وەتس ئەپ"
					loading="lazy"
					referrerpolicy="strict-origin-when-cross-origin"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</div>
</div>
